export type WorldOfTechIconProps = {
  icon?: IconHc;
} & React.SVGProps<SVGSVGElement>;

export enum IconHc {
  CODE = 'code',
  COLLEGE = 'college',
  DAY = 'day',
  DOWN_ARROW = 'down-arrow',
  WORLDOFTECH = 'worldoftech',
  HOME = 'home',
  MENU = 'menu',
  NIGHT = 'night',
  ROBOT = 'robot',
  GITHUB = 'github',
}
